module.exports = __webpack_public_path__ + "media/Emergency-fr_Chantier.b2ee041c.wav";